import React, {Component} from "react";
import CommToolContext from "../common/comm_tool_context";
import {Grid, Row, Col} from "react-flexbox-grid";
import ActiveTabs from "./active_tabs";
import {getProject} from '../../api';

class ActiveProject extends Component {

    constructor(props) {
        super(props);

        this.state = {
            projectId: props.match.params.projectId
        }
    }

    async componentDidMount() {
        const project = await getProject(this.state.projectId);

        this.setState({
            project
        })
    }

    render() {
        const {project} = this.state;

        return (
            <CommToolContext.Consumer>
                {context => (
                    <React.Fragment>
                        <Grid fluid>
                            <Row>
                                <Col xs={12}>
                                    {project && <ActiveTabs project={project} context={context}/>}
                                </Col>
                            </Row>
                        </Grid>
                    </React.Fragment>
                )}
            </CommToolContext.Consumer>
        );
    }
}

ActiveProject.contextType = CommToolContext;
export default ActiveProject;
